import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ConsumerInteractionService } from '../../../services/consumer-interaction.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceInteractionService } from '../../../services/device-interaction.service';
import swal from 'sweetalert2';
import { ClaimsService } from '../../../services/claims.service';
import { DeviceInteractionMultipleModel } from '../../../models/consumer/consumer-bulk-interaction.model';

@Component({
    selector: 'device-interactions-list-multiple',
    templateUrl: './device-interactions-list-multiple.component.html',
    styles: []
})
export class DeviceInteractionsListMultipleComponent implements OnInit {

    constructor(private consumerInteractionService: ConsumerInteractionService,
        private route: ActivatedRoute,
        private router: Router,
        private deviceInteractionService: DeviceInteractionService,
        private claimsService: ClaimsService ) { }

    @Input() data: DeviceInteractionMultipleModel;
    @Output() hasCancelled: EventEmitter<boolean> = new EventEmitter();
    clientId: number;
    subscriptions: any[] = [];
    consumerId: string;
    bulkInteractions: any[] = [];
    myInteractionsCount: number;
    page: number = 1;
    totalItems: number;
    searching: boolean = false;
    totalPages: number;

    ngOnInit() {
        this.clientId = this.route.parent.snapshot.params['clientId'];
        this.subscriptions.push(this.route
            .params
            .subscribe(params => {
                this.consumerId = params['consumerId'];
            }));
    }

    ngOnChanges(changes: any) {
        for (let propName in changes) {
            let chng = changes[propName];
            if (propName == "data" && chng.currentValue) {
                this.bulkInteractions = [];
                this.bulkInteractions = chng.currentValue.items;
                this.page = chng.currentValue.currentPage;
                this.totalItems = chng.currentValue.totalItems;
                this.totalPages = chng.currentValue.totalPages;
                this.myInteractionsCount = chng.currentValue.myInteractionCount;
            }
        }
    }

    clickItem(item: any) {
        this.deviceInteractionService.id = item.id;
        this.router.navigate(['/portal/' + this.clientId.toString() + '/deviceinteractions/bulk']);
    }

    cancelInteraction(item: any) {

        swal({
            title: "Are you sure you want to cancel these interactions?",
            text: "You are about to cancel the following interactions",
            confirmButtonText: 'Yes',
            confirmButtonColor: '#00539f',
            showCancelButton: true,
            cancelButtonText: "No, don't cancel",
            cancelButtonColor: '#00539f',
        }).then(val => {
            if (val.value == true) {

                let userId = this.claimsService.userId;
                this.consumerInteractionService.CancelBulkInteraction(this.clientId, item.id, userId).then(cancelResult => {
                    this.hasCancelled.emit(true);
                }).catch(error => {
                    swal({
                        title: 'Something went wrong',
                        text: 'An error occured, the interactions could not be cancelled at this moment in time, please try again later or contact the switch2 technical team on: XXXX-XXXX-XXXX',
                        type: 'error',
                        confirmButtonText: 'Continue'
                    })
                })
            }
        });
    }
}
